// src/com/trans_plan_tsr/TransPlanTsrEditBulkDetail.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { AppStyle } from '../../value/AppConst';
import VzmIntField from '../../common/VzmIntField';
import { bulkCompanyProductsListRepo } from '../../value/AppModel';
import { useReactiveVar } from '@apollo/client';
import {
    mergeBulkCountAndMakeTwoBulkProductsCompanyTrees
} from '../bulk_company_products/BulkCompanyProductsGql';

const ProductLabelWidth = 100;
const CompanyLabelWidth = 220;
const QuantityLabelWidth = 120;
const TotalWidth = ProductLabelWidth + CompanyLabelWidth + QuantityLabelWidth;

const ColumnBox = styled(Box)({display: 'flex', flexDirection: 'column', flex: 1});
const TitleHeader = styled(Box)({
    backgroundColor: AppStyle.PrimaryRGB, color: 'white', fontWeight: 'bold',
    display: 'flex', height: 40, width: TotalWidth,
});

const ColumnBody = styled(Box)({
    flex: 1, overflowY: 'auto', overflowX: 'hidden', borderBottom: AppStyle.BorderCCC,
    boxSizing: 'border-box', // border: '1px solid green'
});

const TitleCell = styled(Box)({
    display: 'flex', justifyContent: 'center', alignItems: 'center',
})
const ProdTreeBox = styled(Box)({
    display: 'flex', borderBottom: AppStyle.BorderCCC,
    fontSize: '0.8rem', // border: '1px solid red',
    textAlign: 'center', boxSizing: 'border-box',
});
const ProdLabel = styled(Box)({
    backgroundColor: '#eee', width: ProductLabelWidth,
    padding: '10px 0px 10px 0px', // 스크롤하지 않아도 위에 보이도록 ..
    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
});
const ProdTotalQty = styled('div')({color: 'blue', fontSize: '0.7rem',});

const CompanyListBox = styled(Box)({flexGrow: 1});
const CompanyRecord = styled(Box)({
    flexGrow: 1,
    display: 'flex', borderBottom: AppStyle.BorderCCC,
    // even background color
    '&:nth-of-type(odd)': {backgroundColor: '#f9f9f9'},
    '&:last-of-type': {borderBottom: 'none'},
});
const CompanyLabel = styled(Box)({
    flexGrow: 1,
    // width: CompanyLabelWidth,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
});
const InputBox = styled(Box)({width: 100, });

function findIndices(tree, prodId, comId) {
    const prodIndex = tree.findIndex(prod => prod.bulkProductsId === prodId);
    if(prodIndex < 0) return [-1, -1];
    const comIndex = tree[prodIndex].companies.findIndex(com => com.bulkCompanyId === comId);
    if(comIndex < 0) return [-1, -1];
    return [prodIndex, comIndex];
}

const DataKey = 'bulkItemList'; // 저장하지 않으면 저장하는 데이터에서도 undefined 되며, 그것이 의도임. bulkItems로 하지 말것.

function sumQuantities(tree) {
    let sum = 0;
    tree.forEach(prod => {
        prod.companies.forEach(com => {
            sum += com.quantity;
        });
    });
    return sum;
}

export default function TransPlanTsrEditBulkDetail({
    item,
    onChangeValue
}) {
    const bulkCompanyProductsListData = useReactiveVar(bulkCompanyProductsListRepo);
    const [productTrees, setProductTrees] = useState([[], []]);
    const [twoSums, setTwoSums] = useState([0, 0]);

    useEffect(()=>{
        if(item && bulkCompanyProductsListData.records.length > 0) {
            const newTrees = mergeBulkCountAndMakeTwoBulkProductsCompanyTrees(bulkCompanyProductsListData.records, item.bulkItemList || item.bulkItems || []); // 982라 하더라도 bulkItems가 없는 경우 있음.
            setProductTrees(newTrees);

            const sumOne = sumQuantities(newTrees[0]);
            const sumTwo = sumQuantities(newTrees[1]);
            setTwoSums([sumOne, sumTwo]);

            /* const newMap = {};
            newTrees.forEach(products => {
                products.forEach(product => {
                    product.companies.forEach(company => {
                        newMap[`${company.bulkProductsId}_${company.bulkCompanyId}`] = company.quantity;
                    });
                });
            }); */
        }
    }, [bulkCompanyProductsListData, item]);

    const onChangeQuantity = (id, val, error) => {
        const value = val < 0 ? 0 : val > 999999 ? 999999 : val;
        // id: `${bulkProductsId}_${bulkCompanyId}`
        const [bulkProductsId, bulkCompanyId] = id.split('_').map(v => parseInt(v));
        // find record
        let treeIndex = 0;
        let [prodIndex, comIndex] = findIndices(productTrees[0], bulkProductsId, bulkCompanyId);
        if(prodIndex < 0 || comIndex < 0) {
            [prodIndex, comIndex] = findIndices(productTrees[1], bulkProductsId, bulkCompanyId);
            treeIndex = 1;
        }
        if(prodIndex < 0 || comIndex < 0) {
            console.error(`Not found: ${id}`);
            return;
        }
        const newTree = [...productTrees];
        newTree[treeIndex][prodIndex].companies[comIndex].quantity = value;
        setProductTrees(newTree);

        const newBulkItems = [];
        // 0보다 큰 것들만 모아서 onChangeValue로 보내기
        newTree.forEach(products => {
            products.forEach(product => {
                product.companies.forEach(company => {
                    if(company.quantity > 0) {
                        newBulkItems.push({
                            planId: item.planId,
                            bulkCompanyId: company.bulkCompanyId,
                            bulkProductsId: product.bulkProductsId,
                            quantity: company.quantity
                        });
                    }
                });
            });
        });
        onChangeValue(DataKey, newBulkItems);
    };

    const renderCompany = (company) => {
        const inputId = `${company.bulkProductsId}_${company.bulkCompanyId}`;
        return (
            <CompanyRecord key={company.bulkCompanyId}>
                <CompanyLabel
                    style={{
                        color: company.quantity > 0 ? 'blue' : 'inherit'
                    }}
                >{company.comName}</CompanyLabel>
                <InputBox>
                    <VzmIntField
                        dict={{id:inputId, check: (value) => value >=0 && value <= 999999}}
                        value={company.quantity}
                        onChange={onChangeQuantity}
                        fullWidth={true}
                        style={{width: QuantityLabelWidth-15}}
                    />
                </InputBox>
            </CompanyRecord>
        );
    };

    const renderProductTree = (product, idx) => {
        const qtyAll = product.companies.reduce((acc, cur) => acc + cur.quantity, 0);
        if(product.prodName === '기타' && product.companies.length === 1 && product.companies[0].comName === '기타') {
            return(
                <ProdTreeBox key={product.bulkProductsId}>
                    <CompanyListBox>
                        {product.companies.map(renderCompany)}
                    </CompanyListBox>
                </ProdTreeBox>
            );
        }

        return (
            <ProdTreeBox key={product.bulkProductsId}>
                <ProdLabel style={{backgroundColor: idx % 2 === 0 ? '#eee' : '#ddd'}}>
                    {product.prodName}
                    {
                        qtyAll > 0 && product.companies.length > 0 &&
                        <ProdTotalQty>[{qtyAll}]</ProdTotalQty>
                    }
                </ProdLabel>
                <CompanyListBox>
                    {product.companies.map(renderCompany)}
                </CompanyListBox>
            </ProdTreeBox>
        )
    }

    return (
        <Box
            style={{
                position: 'absolute', top: 5, left: 0, right: 0, bottom: 0,
                display: 'flex', 
            }}
        >
            <ColumnBox style={{paddingRight: 2}}>
                <TitleHeader>
                    <TitleCell style={{width: ProductLabelWidth}}>구분</TitleCell>
                    <TitleCell style={{width: CompanyLabelWidth}}>협력업체명</TitleCell>
                    <TitleCell style={{flexGrow:1}}>
                        Pallet
                        {
                            twoSums[0] > 0 &&
                            <span>[{twoSums[0]}]</span>
                        }
                    </TitleCell>
                </TitleHeader>
                <ColumnBody>
                    {productTrees[0].map(renderProductTree)}
                </ColumnBody>
            </ColumnBox>
            <ColumnBox style={{paddingLeft: 2}}>
                <TitleHeader>
                    <TitleCell style={{width: ProductLabelWidth}}>구분</TitleCell>
                    <TitleCell style={{width: CompanyLabelWidth}}>협력업체명</TitleCell>
                    <TitleCell style={{flexGrow:1}}>
                        Pallet
                        {
                            twoSums[1] > 0 &&
                            <span>[{twoSums[1]}]</span>
                        }
                    </TitleCell>
                </TitleHeader>
                <ColumnBody>
                    {productTrees[1].map(renderProductTree)}
                </ColumnBody>
            </ColumnBox>

        </Box>
    )
}